<template>
    <div class="qwen_ai_menu">
        <div class="logo_name">
            <div class="logo_name_left">
                <div class="logo">
                    <img src="@/assets/image/qwen/logo.png" alt="" class="image">
                </div>
                <div class="title_description">
                    <div class="title">
                        <span>初新AI</span>
                    </div>
                    <div class="description">
                        <span>企业AI工作台</span>
                    </div>
                </div>
            </div>
            <div class="open_contraction">
                <MenuFoldOutlined />
            </div>
        </div>
        <div class="sidebar_menu_box">
            <a-menu mode="vertical" :selected-keys="selectedKeys" class="sidebar_menu">
                <a-menu-item key="/ai/aiAgent" @click="onGoPath('/ai/aiAgent')">新建对话</a-menu-item>
                <a-menu-item key="/ai/outputManagement" @click="onGoPath('/ai/outputManagement')">产出管理</a-menu-item>
                <a-menu-item key="/ai/knowledgeBase" @click="onGoPath('/ai/knowledgeBase')">企业知识库</a-menu-item>
                <a-menu-item key="/ai/skillManagement" @click="onGoPath('/ai/skillManagement')">技能管理</a-menu-item>
            </a-menu>
        </div>
        <div class="recent_tasks">
            <div class="recent_tasks_title">
                <div class="title_left">
                    <span>最近任务</span>
                </div>
                <div class="title_right">
                    <PlusOutlined class="icon" />
                </div>
            </div>
            <div class="two_title">
                <span>今天</span>
            </div>
            <div class="tasks_row">
                <ClockCircleOutlined />
                <span>家居行业品牌心智排名分析</span>
            </div>
            <div class="tasks_row">
                <ClockCircleOutlined />
                <span>生成 Q3 渠道增长复盘</span>
            </div>
            <div class="two_title">
                <span>本周</span>
            </div>
            <div class="tasks_row">
                <ClockCircleOutlined />
                <span>竞品新品上架策略研究</span>
            </div>
            <div class="tasks_row">
                <ClockCircleOutlined />
                <span>客户流失原因诊断</span>
            </div>
            <div class="tasks_row">
                <ClockCircleOutlined />
                <span>销售周报自动生成</span>
            </div>
        </div>  
    </div>
</template>

<script setup>
import {
    PlusOutlined,
    ClockCircleOutlined,
    MenuFoldOutlined
} from '@ant-design/icons-vue';
import { useRouter } from 'vue-router';
import { onMounted, ref } from 'vue';

const router = useRouter();
const selectedKeys = ref(['new']);

/**
 * @function 跳转
 * @param path 
 */
const onGoPath = (path) => {
    selectedKeys.value = [path];
    router.push(path);
};

onMounted(() => {
    selectedKeys.value = [location.pathname];
});

</script>

<style lang="scss">
.qwen_ai_menu {
    width: 252px;
    height: calc(100vh);
    padding: 22px 14px 16px;
    background: #f9fafdeb;
    border-right: 1px solid #e8eaf0;

    .logo_name {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .logo_name_left {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 10px;

            .image {
                width: 36px;
                height: 36px;
                background: linear-gradient(145deg, #8069ff, #5f7cf4);
                border-radius: 12px;
                box-shadow: 0 7px 18px #6b66f538;
            }
        }

        .title_description {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;

            .title {
                font-size: 16px;
                font-weight: bold;
            }

            .description {
                font-size: 12px;
                color: #858b98;
            }
        }
    }

    .sidebar_menu_box {
        padding: 16px 0 24px 0;
        border-bottom: 1px solid #eee;

        .sidebar_menu {
            border-right: none;
            border-inline-end: 0 !important;
            background: rgba($color: #000000, $alpha: 0);
        }
    }

    .recent_tasks {
        .recent_tasks_title {
            display: flex;
            align-content: center;
            justify-content: space-between;
            color: #777d89;
            font-size: 14px;
            padding: 16px 0;

            .icon {
                font-size: 16px;
                cursor: pointer;
            }
        }

        .two_title {
            color: #777d89;
            font-size: 14px;
            padding: 0 4px 16px;
        }

        .tasks_row {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 8px;
            font-size: 13px;
            color: #777d89;
            padding: 0 4px 16px;
        }
    }
}
</style>